import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function AppelPersonnel({}: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        Je sais que vous ne voulez pas que l'on vous dérange ce matin, mais
        votre femme insiste pour vous parler. Il semble que ce soit très urgent.
      </p>
      <p>Puis je vous transférer l'appel ?</p>
      <MailSignature
        emetteurLogo={AppelPersonnel.metadata.emetteurLogo}
        emetteur={AppelPersonnel.metadata.emetteur}
        emetteurPoste={AppelPersonnel.metadata.emetteurPoste}
        emetteurEntreprise={AppelPersonnel.metadata.emetteurEntreprise}
      />
    </div>
  );
}

AppelPersonnel.metadata = {
  titre: "Appel personnel",
  cleMail: "appel_personnel",
  messageTransfert: false,
  emetteur: "Nicole SON",
  emetteurPoste: "Assistante de Direction",
  emetteurEntreprise: "SYTEL France",
  emetteurLogo: "/logos/sytel_france.png",
  dateRelative: 0,
  piecesJointes: [],
} as MailMetadata;

export default AppelPersonnel;
